import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import tw from "tailwind-styled-components";
import { FaBolt, FaRegFileAlt, FaTools, FaUtensils, FaHandshake, FaExclamationCircle, FaRunning, FaBroom, FaLink, FaWifi } from 'react-icons/fa';
import { GiExpense, GiWashingMachine } from "react-icons/gi";
import { GrVmMaintenance } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter, truncateText } from "../../../helpers";
import { PaginationLimit } from "../../../Config";
import Images from "../../../Images";
import { NextBtn, PaginationWrapper, PrevBtn } from "../../Styles/PageStyles";
import Tooltip from "../../Tooltip";
import { renderExtraChargeType } from "../../../utilities/extraChargeConfig";

const ExtraChargesTable = ({
    apiData,
    propertyDetails,
    setShowLinkUnlinkModel,
    setSelectedData
}) => {
    const navigate = useNavigate();
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const unlinkCharge = (item) => {
        setShowLinkUnlinkModel(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        return (
            <div className="flex items-center gap-3">
                <Tooltip label="Click to unlink the charges from this property">
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            unlinkCharge(item);
                        }}
                        className="text-gray-400 hover:text-blue-600 transition bg-gray-50 hover:bg-gray-100 rounded-full p-3"
                    >
                        <FaLink size={12} />
                    </button>
                </Tooltip>
                {item.type === 4 &&
                    <Tooltip label="Click to add electricity bill">
                        <button
                            onClick={() => {
                                navigate('/electricity-bill', { state: { propertyDetails: propertyDetails } });
                                setOpenActionMenu(null);
                            }}
                            className="text-gray-400 hover:text-blue-600 transition bg-gray-50 hover:bg-gray-100 rounded-full p-3"
                        >
                            {/* Edit */}
                            <FaBolt size={12} />
                        </button>
                    </Tooltip>}
            </div>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                property: getProperty(),
                amount: <Amount>{'₹' + item.amount}</Amount>,
                type: renderExtraChargeType(item.type),
                repetition: getRepetition(item.repetitionType),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getProperty = () => {
        const name = capitalizeFirstLetter(propertyDetails?.name || 'N/A');
        return (
            <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
                {truncateText(name, 35)}{" "}
            </span>
        );
    };

    const getRepetition = (type) => {
        const isMonthly = type !== 1;

        return (
            <span
                className={`text-xs font-medium px-2.5 py-1 rounded-full
        ${isMonthly
                        ? "bg-blue-50 text-blue-700"
                        : "bg-gray-100 text-gray-600"
                    }`}
            >
                {isMonthly ? "Monthly" : "One-Time"}
            </span>
        );
    };


    // const getType = (type) => {
    //     if (type === 4) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaBolt className="text-blue-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Electricity</p>
    //             </div>
    //         );
    //     } else if (type === 5) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaRegFileAlt className="text-green-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Registration</p>
    //             </div>
    //         );
    //     } else if (type === 6) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaTools className="text-yellow-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Tech Charges</p>
    //             </div>
    //         );
    //     } else if (type === 9) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaUtensils className="text-red-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Food</p>
    //             </div>
    //         );
    //     } else if (type === 3) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <GrVmMaintenance className="text-teal-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Maintenance</p>
    //             </div>
    //         );
    //     } else if (type === 8) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaHandshake className="text-purple-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Agreement Charges</p>
    //             </div>
    //         );
    //     } else if (type === 10) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaExclamationCircle className="text-purple-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Fine</p>
    //             </div>
    //         );
    //     }
    //     else if (type === 19) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaRunning className="text-rose-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Move Out Charges</p>
    //             </div>
    //         );
    //     }
    //     else if (type === 14) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaBroom className="text-teal-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Maid Charges</p>
    //             </div>
    //         );
    //     }
    //     else if (type === 17) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <GiWashingMachine className="text-blue-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Laundry Charges</p>
    //             </div>
    //         );
    //     }
    //     else if (type === 12) {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <FaWifi className="text-teal-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Wi-Fi</p>
    //             </div>
    //         );
    //     } else {
    //         return (
    //             <div className="flex items-center gap-2">
    //                 <GiExpense className="text-orange-500 mr-2 w-5 h-5" />
    //                 <p className="text-base text-gray-700">Other</p>
    //             </div>
    //         );
    //     }
    // };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Type",
                    accessor: "type",
                },
                {
                    Header: "Amount",
                    accessor: "amount",
                },

            ];
        }
        return [
            {
                Header: "Type",
                accessor: "type",
            },

            {
                Header: "Repetition",
                accessor: "repetition",
            },

            {
                Header: "Amount",
                accessor: "amount",
            },

            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">

                                                <li className="flex gap-2">
                                                    <strong>Amount:</strong> {data[rowIndex].amount}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Repetition:</strong> {data[rowIndex].repetition}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`text-gray-800 text-sm font-semibold  bg-neutral-100 px-3 py-1 rounded-full inline-flex`

export default ExtraChargesTable;
